module.exports = __webpack_public_path__ + "static/media/kv.40c83737.png";